import { JDDevice } from '@jdreact/jdreact-core-lib';

const deviceWidth = JDDevice.width;

export default deviceWidth;
